import { WebStoreId } from "@/shared/@types/WebStoreId";
import { isNotProduction } from "@/shared/helper/environment.helper";

export const isWebStoreWithCommentSection = (
  webStoreId: WebStoreId,
): boolean => {
  const webStoresWithCommentSection = [
    WebStoreId.NL,
    WebStoreId.BE,
    WebStoreId.CH,
  ];
  return webStoresWithCommentSection.includes(webStoreId);
};

export const isWebStoreWithPickupOption = (webStoreId: WebStoreId): boolean => {
  // TODO remove the env differentiation when pickup goes live for DE as well
  const webStoresWithPickupOptionProduction = [WebStoreId.CH];
  const webStoresWithPickupOptionStaging = [WebStoreId.DE, WebStoreId.CH];
  return isNotProduction()
    ? webStoresWithPickupOptionStaging.includes(webStoreId)
    : webStoresWithPickupOptionProduction.includes(webStoreId);
};

export const isWebStoreWithRGoodsAndSystemBottles = (
  webStoreId: WebStoreId,
): boolean => {
  const webStoresWithRGoodsAndSystemBottles = [
    WebStoreId.AT,
    WebStoreId.BE,
    WebStoreId.CH,
    WebStoreId.DE,
    WebStoreId.NL,
  ];
  return webStoresWithRGoodsAndSystemBottles.includes(webStoreId);
};

export const isWebStoreWithRGoodsAndSystemBottlesReturn = (
  webStoreId: WebStoreId,
): boolean => {
  const webStoresWithRGoodsAndSystemBottles = [WebStoreId.DE, WebStoreId.AT];
  return webStoresWithRGoodsAndSystemBottles.includes(webStoreId);
};

export const isWebStoreWithPalletConfigurator = (
  webStoreId: WebStoreId,
): boolean => {
  const webStoresWithPalletConfigurator = [WebStoreId.GG_DE];
  return webStoresWithPalletConfigurator.includes(webStoreId);
};

export const isWebStoreWithGasMixtureConfigurator = (
  webStoreId: WebStoreId,
): boolean => {
  const webStoresWithGasMixtureConfigurator = [
    WebStoreId.AT,
    WebStoreId.BE,
    WebStoreId.CH,
    WebStoreId.DE,
    WebStoreId.FR,
    WebStoreId.NL,
  ];
  return webStoresWithGasMixtureConfigurator.includes(webStoreId);
};
